import { Component, OnInit, Input } from '@angular/core';
import { VariableCircuitoOut, VariableCircuitoIn } from '../../../infrastructure/services/usuarios.service';

@Component({
  selector: 'custom-block-atributo',
  templateUrl: 'customBlockAttribute.component.html'
})
export class CustomBlockAtributoComponent implements OnInit {
  @Input() atributo: VariableCircuitoOut;
  inputs: VariableCircuitoIn[] = []; // Store para los valores ingresados
  nuevoInput: VariableCircuitoIn;
  constructor() { }

  ngOnInit() {
    this.nuevoInput = {
      codigo: this.atributo.codigo,
      valor:  '',
    };
  }

  agregarInput() {
    this.inputs.push(this.nuevoInput);
    this.nuevoInput = {
      codigo: this.atributo.codigo,
      valor:  '',
    };
  }

  removerInput(index) {
    if (index > -1) {
      this.inputs.splice(index, 1);
    }
  }

  getValues(): VariableCircuitoIn[] {
    const defaultVariable: VariableCircuitoIn = {
      codigo: this.atributo.codigo + '|1',
      valor: '',
    };

    if (this.inputs.length > 0) {
      return this.inputs.map((input, index) => ({...input, codigo: `${input.codigo}\|${(index + 1)}`}));
    }
    return [defaultVariable];
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/helpers/components/customAttributeBlock/customBlockAttribute.component.ts